import { useCallback } from 'react';

import useSentinelTeam from 'hooks/useSentinelTeam';
import { alertTypeText } from 'utils/Alerts';

type AlertTypeTextFn = (
  alert: unknown,
  count?: number,
  title?: string,
) => string | null;

/**
 * `alertTypeText` bound to the current team's wording.
 *
 * The only label that varies is the recall one: teams inside an OEM segment see
 * "Active Campaign(s)", everyone else keeps "Active Recall(s)" (PD-4757). Use
 * this rather than importing `alertTypeText` directly, so a component picks the
 * right wording without knowing why it differs.
 */
export default function useAlertTypeText(): AlertTypeTextFn {
  const { belongsToOemSegment } = useSentinelTeam();

  return useCallback(
    (alert, count, title) =>
      alertTypeText(alert, count, title, { oemSegment: belongsToOemSegment }),
    [belongsToOemSegment],
  );
}
